// extracted by mini-css-extract-plugin
export default {"blogrecent":"RecentBlogs_blogrecent__HUVl4","rightblog":"RecentBlogs_rightblog__t0x2v"};